import { render, staticRenderFns } from "./V2InvoiceEdit.vue?vue&type=template&id=0b7db0f6&"
import script from "./V2InvoiceEdit.vue?vue&type=script&lang=js&"
export * from "./V2InvoiceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports